<div class="manual-usuario-container">
  <iframe
    [src]="manualUrl"
    class="manual-iframe"
    frameborder="0">
  </iframe>
</div>
